export default "__VITE_ASSET__CdlmphsF__"